module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._m(0), " ", _vm._h('div', {
    staticClass: "main-page class-edit"
  }, [_vm._h('div', {
    staticClass: "wifiless text-center"
  }, [_vm._h('div', {
    staticClass: "wifi-wrap"
  }, [_vm._h('p', {
    staticClass: "font-14 padding-15"
  }, ["啊哦，网络不太顺畅哦~"]), " ", _vm._h('span', {
    staticClass: "button button-rounded button-primary font-14",
    staticStyle: {
      "padding": "0 30px",
      "width": "60px",
      "height": "40px",
      "line-height": "40px",
      "margin": "0 auto"
    },
    on: {
      "click": _vm.checkNetwork
    }
  }, ["重新加载"])])])])])
},staticRenderFns: [function (){var _vm=this;
  return _vm._h('div', {
    staticClass: "topbar"
  }, [_vm._h('div', {
    staticClass: "clearfix main-wrap"
  }, [_vm._h('h1', ["网络异常"])]), " ", _vm._h('div', {
    staticClass: "liner"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.1@vue-loader/lib/template-compiler.js?id=data-v-077ecd0c!./~/.10.0.1@vue-loader/lib/selector.js?type=template&index=0!./src/views/networkLess.vue
// module id = 174
// module chunks = 1